export type CustomerServiceSource =
  | 'login'
  | 'register-route'
  | 'forgot-password'
  | 'onboarding'
  | 'floating-support';

export function customerServiceUrl(source: CustomerServiceSource): string {
  const params = new URLSearchParams({ source });
  const channelCode = new URLSearchParams(window.location.search).get('channelCode');
  if (channelCode) params.set('channelCode', channelCode);
  return `/customer-service/go?${params.toString()}`;
}

export function openCustomerService(source: CustomerServiceSource): void {
  window.location.assign(customerServiceUrl(source));
}
